import { DateTime } from 'luxon';

/**
 * Classe de manipulation/présentation des bornes de tous les projets présentés
 */
export class ProjectsExtremas
{
    constructor (public minExtrema: DateTime, public maxExtrema: DateTime)
    {
    }

    toString (): string
    {
        if (!this.minExtrema)
        {
            return '--';
        }

        return `${this.minExtrema.toISO()} - ${this.maxExtrema.toISO()}`;
    }

    public static compare = (pea: ProjectsExtremas, peb: ProjectsExtremas): boolean => pea.toString() === peb.toString();
}
